export function formatLargeNumbers(value: any, restrictToMillions: boolean, title: string, isDatabrick: boolean = false) {
    let restrictToMillion = restrictToMillions || false;
    if (restrictToMillion && (value >= 1000000 || value >= 1000)) {
        return (title == 'Cost Trend' || isDatabrick) ? '$' + (value / 1000000).toFixed(2) + 'MM': (value / 1000000).toFixed(2) + 'MM';
    } else if (!restrictToMillion && value >= 1000000) {
        return (value / 1000000).toFixed(2) + 'MM';
    } else if (!restrictToMillion && value >= 1000) {
        return (value / 1000).toFixed(2) + 'K';
    } else {
        return value?.toString() || value;
    }
}

export function formatDateAndValue([dateString, value]: [string, number], restrictToMillions: boolean, title: string, isDatabrick: boolean, isYearly: boolean) {
    const [year, month] = dateString.split('-');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthName = monthNames[Number.parseInt(month, 10) - 1];
    const formattedValue = formatLargeNumbers(value, restrictToMillions, title);
    if(isYearly)
        return `${year}: ${formattedValue}`;
    return `${monthName}-${year}: ${formattedValue}`;
}

export function formatDateAndValueForIbp([dateString, value]: [string, number]) {
    const [year, month] = dateString.split('-');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthName = monthNames[Number.parseInt(month, 10) - 1];
    return `${monthName}-${year}: ${value}`;
}